import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import Error404 from './views/Errors/Error404';
import routes from './routes';
import 'antd/dist/antd.css';

library.add(fas, fab, far);

function App() {
  return (
    <BrowserRouter>
      <Switch>
        {
          routes.map((route) => (
            <Route
              key={Math.random()}
              path={route.path}
              exact={route.exact}
              component={(props) => (
                <route.layout {...props}>
                  <route.component {...props} />
                </route.layout>
              )}
            />
          ))
        }
        <Route component={Error404} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
